import Constant from '@/common/constant/Constant';
import { Button, IconButton, Tooltip } from '@material-ui/core';
import { I18n } from 'aws-amplify';
import { getPanelType } from './handler/CreateTicketCommonHandler';
import { disabledAllField } from './handler/KnowledgeTicketHandler';
import Utils from '@/common/utils/utils';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { closePanelTabSelector, setPanelSelector } from '@/state/selector/panelSelector';
import { multiPanelAtom } from '@/state/atom/panelAtom';
import { corporationAtom } from '@/state/atom/corporationAtom';
import { userAtom } from '@/state/atom/userAtom';
import { projectIdListUserIsB2CAtom } from '@/state/atom/projectAtom';
import './ButtonSubmitAddTicket.css';

const ButtonSubmitAddTicket = props => {
    const userDetail = useRecoilValue(userAtom);
    const projectIdListUserIsB2C = useRecoilValue(projectIdListUserIsB2CAtom);
    
    const { onClick, onClickDraft, onClickDelete, ticketType, isEdited } = {...props};
    let isDuplicate = props.isDuplicate ? true : false;
    const isDisableButtonDraft = props.isDisableButtonDraft ? true : false;
    const isDisableButtonSent = props.isDisableButtonSent ? true : false;
    const isShowButtonDelete = props.isEnableButtonDelete && !isDuplicate ? true : false;
    const addNewPanel = useSetRecoilState(setPanelSelector);
    const panelList = useRecoilValue(multiPanelAtom);
    const closePanelTab = useSetRecoilState(closePanelTabSelector);
    const corporationDetail = useRecoilValue(corporationAtom);

    const detailTicket = props?.detailTicket;

    function onSubmitHandle() {
        onClick();
    }

    const onSubmitSaveDraftHandle = () => {
        // onClick(Constant.QA_FILTER_STATUS.DRAFT);
        onClickDraft();
    };

    const onClickButtonClose = () => {
        if (props.isEdited) {
            props.setIsConfirmCancelCreateTicket(true);
        } else {
            props.closePanelTab({
                event: null,
                panelType: getPanelType(props.panelList, props.panelId),
                panelId: props.panelId,
                tabId: props.tabId
            });
        }
    };

    const onClickButtonDelete = () => {
        onClickDelete();
    };

    const isEnableButtonCancelForDuplicate = () => {
        if (isDuplicate) return false;
        return disabledAllField(props.panelList, props.tabId, props.handleStatus);
    }

    const isEnableButtonDraftForDuplicate = () => {
        if (isDuplicate) return false;
        return isDisableButtonDraft ||
            disabledAllField(props.panelList, props.tabId, props.handleStatus);
    }

    const isEnableButtonSentForDuplicate = () => {
        if (isDuplicate && !isEdited) return false;
        return isDisableButtonSent ||
            disabledAllField(props.panelList, props.tabId, props.handleStatus);
    }


    const onOpenKnowledge = () => {

        const existedKnowledgeHelpdeskTicketListPanel = panelList.find(
            panel => (Constant.PANEL_TYPE.KNOWLEDGE_HELPDESK_TICKET_LIST, Constant.PANEL_TYPE.KNOWLEDGE_TICKET_LIST).includes(panel.type)
        );
        
        if (!Utils.isEmptyObject(existedKnowledgeHelpdeskTicketListPanel)) {
            closePanelTab({
                event: null,
                panelType: existedKnowledgeHelpdeskTicketListPanel.type,
                panelId: existedKnowledgeHelpdeskTicketListPanel.id,
                tabId: 'knowledge_ticket_list_tab'
            });
        }

        let addNewPanelParams = {
            type: Constant.PANEL_TYPE.KNOWLEDGE_TICKET_LIST,
            componentName: Constant.COMPONENT_NAME.LIST_TICKET_KNOWLEDGE,
            tabId: 'knowledge_ticket_list_tab',
            visibilitySettingType: Constant.VISIBILITY_SETTING_TYPE.CUSTOMER,
            isCustomer: true,
            customerId: userDetail.id,
            projectSelectedId: props.projectTarget,
            corporationSelectedId: props.corporationTarget,
            props : {
                ...props,
                componentName: Constant.COMPONENT_NAME.LIST_TICKET_KNOWLEDGE,
                panelType: Constant.PANEL_TYPE.KNOWLEDGE_TICKET_LIST
            }
        }
        // if (
        //     ![
        //         Constant.USER_PERMISSION_VIEW_KNOWLEDGE.MEMBER_OF_PROJECT,
        //         Constant.USER_PERMISSION_VIEW_KNOWLEDGE.PERSONAL_PROJECT
        //     ].includes(userPermissionView.type)
        // ) {
        //     addNewPanelParams.visibilitySettingType = Constant.VISIBILITY_SETTING_TYPE.CUSTOMER
        //     addNewPanelParams.isCustomer = true
        //     addNewPanelParams.customerId = userPermissionView.projectSelectedId
        // }
        addNewPanel(addNewPanelParams)
    };

    const renderButtonSendTicket = () => {
        let labelButton = I18n.get('USER04BTN001');
        let ticketTypeOfTicket = props?.createTicketType ? props?.createTicketType : props?.ticketType
        switch (ticketTypeOfTicket) {
            case Constant.TICKET_TYPE.MASTER_KNOWLEDGE:
            case Constant.TICKET_TYPE.KNOWLEDGE:
                labelButton = props.isDraft ? '公開' : I18n.get('COMBTN011');
                break;
            case Constant.TICKET_TYPE.INVITATION_GUEST_DESK_PROJECT:
                labelButton = I18n.get('USER03BTN011');
                break;
            default:
                labelButton = I18n.get('USER04BTN001');
                break;
        }

        if (
            (props?.editTicket &&
            props?.createTicketType !== Constant.TICKET_TYPE.INVITATION_GUEST_DESK_PROJECT) || isDuplicate
        ) {
            labelButton = I18n.get('COMBTN011');
        }

        return (
            <Button
                className="btn-send  btn-primary btn-hg32"
                variant="contained"
                color="primary"
                disabled={
                    isEnableButtonSentForDuplicate()
                }
                onClick={e => onSubmitHandle()}
                data-cy="btn-submit-add-ticket"
            >
                {labelButton}
            </Button>
        );
    };

    const isDisplayIconViewHelpdeskKnowledge = () => {
        if (!ticketType || ticketType !== Constant.TICKET_TYPE.QA) {
            return false;
        }

        if (
            Utils.isEmptyString(props.projectTarget) ||
            Utils.getPrefixOfId(props.projectTarget) !== 'project'
        ) {
            return false;
        }

        if (props.corporationTarget) {
            if (props.corporationTarget === corporationDetail.id) {
                // Disable when user is not B2C of project
                if (userDetail && Utils.isB2CUser(userDetail)) {
                    if (Utils.isEmptyArray(projectIdListUserIsB2C) || !projectIdListUserIsB2C.includes(props.projectTarget)) return false;
                }

                return corporationDetail.knowledgeService === Constant.ACTIVE_FLAG.ACTIVE;
            } else {
                let listHelpdesk = [...props.externalHelpDeskList];
                let projectTargetData = listHelpdesk.find(
                    project => project.id === props.projectTarget
                );

                if (!projectTargetData || Utils.isEmptyObject(projectTargetData)) {
                    return false;
                }

                const corporationData = projectTargetData?.corporationData;
                if(Utils.isEmptyObject(corporationData)) {
                    return false;
                }

                const contractType = corporationData.contractType;
                if (contractType === Constant.CORPORATION_CONTRACT_TYPE.PREMIUM) {
                    return (
                        projectTargetData?.corporationData?.knowledgeService ===
                        Constant.ACTIVE_FLAG.ACTIVE
                    );
                } else {
                    const inviterSetting = Utils.convertJSONDataToObject(
                        corporationData.inviterSetting
                    );
                    return inviterSetting?.usingKnowledgeService === Constant.ACTIVE_FLAG.ACTIVE;
                }
            }
        }

        return false;
    };

    return (
        <div className="col2">
            <div className="itemAddticket btn-addTicket-container">
                <div className="wrap-btn-submit">
                    {isDisplayIconViewHelpdeskKnowledge() && (
                        <div className="itemButton">
                           <Tooltip title={I18n.get('KNOWLILB005')} placement='top' arrow >
                                <IconButton className="itemNav">
                                    <img
                                        src="/assets/image/icon-link.svg"
                                        alt=""
                                        onClick={onOpenKnowledge}
                                    />
                                </IconButton>
                            </Tooltip>
                        </div>                        
                    )}

                    <div className="wrap-btn-add">
                        {!Utils.isEmptyString(detailTicket?.deletedAt) ? (
                            <>
                                <Button
                                    className="btn-send btn-delete btn-hg32"
                                    variant="contained"
                                    color="primary"
                                    onClick={() => props.setIsShowDialogDeleteTicket(true)}
                                >
                                    完全削除
                                </Button>
                                <Button
                                    className="btn-send btn-outline-primary btn-hg32"
                                    variant="contained"
                                    color="primary"
                                    onClick={() => props.setIsShowDialogRestoreTicket(true)}
                                >
                                    復元
                                </Button>
                            </>
                        ) : (
                            <>
                                {/* <Button
                                    className="btn-send btn-light btn-hg32 button-submit-add-ticket"
                                    variant="contained"
                                    color="primary"
                                    onClick={() => onClickButtonClose()}
                                    disabled={isEnableButtonCancelForDuplicate()}
                                >
                                    {I18n.get('COMBTN001')}
                                </Button> */}
                                {isShowButtonDelete && (
                                    <Button
                                        className="btn-send btn-delete btn-hg32"
                                        variant="contained"
                                        // disabled={isShowButtonDelete}
                                        onClick={() => onClickButtonDelete()}
                                        disabled={disabledAllField(
                                            props.panelList,
                                            props.tabId,
                                            props.handleStatus
                                        )}
                                    >
                                        {I18n.get('COMBTN013')}
                                    </Button>
                                )}
                                <Button
                                    className="btn-send btn-outline-primary btn-hg32 button-submit-add-ticket"
                                    variant="contained"
                                    color="primary"
                                    disabled={
                                        isEnableButtonDraftForDuplicate()
                                    }
                                    onClick={e => onSubmitSaveDraftHandle()}
                                >
                                    {I18n.get('CM-BUTTON-SAVE-AS-DRAFT')}
                                </Button>
                                {renderButtonSendTicket()}
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ButtonSubmitAddTicket;
